













import { Component, Prop, Vue } from "vue-property-decorator";
import CzTitle from "./CzTitle.vue";

@Component({ components: { CzTitle } })
export default class CzSection extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) subtitle!: string;
}
